<bic-popup (close)="onCancel()" [hasBackdrop]="true" [title]="'Möchten Sie die Organisation '+ '“' +data.organisation.name + '”' +' löschen?'" customClass="w-[560px] h-fit">
  <div bicPopupContent class="flex flex-col">
    <span class="font-normal">Bei Bestätigung wird die Organisation “{{ data.organisation.name }}” unwiderruflich gelöscht. Alle Mitglieder verlieren mit sofortiger Wirkung den Zugriff auf  Projektdaten, Prüfergebnisse und Organisationsverwaltung.</span>
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end items-center gap-4">
    <bic-button (onClick)="onCancel()" buttonType="white">Abbrechen</bic-button>
    <bic-button (onClick)="delete()" buttonType="red">Löschen</bic-button>
  </div>
</bic-popup>
